<template>
	<v-layout row justify-center>
		<v-dialog v-model="isLoading" persistent fullscreen content-class="loading-dialog">
			<v-container fill-height>
				<v-layout row justify-center align-center>
					<v-progress-circular indeterminate :size="70" :width="7" color="blue-grey"></v-progress-circular>
				</v-layout>
			</v-container>
		</v-dialog>
	</v-layout>
</template>


<script>
	export default {
		props: {
			isLoading: {
				type: Boolean,
				required: true
			}
		}
	}
</script>